export const engagementAppGroupIdStructuralTemplateCanvasTemplateClonedStepsData =
  "/engagement/:app_group_id/structural_template/canvas_template_cloned_steps_data";
